import classNames from "classnames";
import styles from "./style.module.scss";

interface ContentBodyLoaderProps {
  center?: boolean;
  size?: number;
  text?: string;
  className?: string;
}

export default function ContentBodyLoader({
  center = false,
  size,
  text,
  className,
}: ContentBodyLoaderProps) {
  return (
    <div className={classNames(styles.loaderWrapper, className)}>
      <div
        style={size ? { height: size, width: size } : {}}
        className={classNames(styles.contentBodyLoader, {
          [styles.center]: center,
        })}
      ></div>
      {text && <div className={styles.loaderText}>{text}</div>}
    </div>
  );
}
